import * as Analytics from 'utils/analytics';
import PropTypes from 'prop-types';
import React from 'react';
import { findDOMNode } from 'react-dom';

class TrackedLink extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    trackingProperties: PropTypes.shape({
      'Link Name': PropTypes.isRequired
    }).isRequired,
    eventName: PropTypes.string
  };

  static defaultProps = {
    eventName: 'Clicked Link'
  };

  componentDidMount() {
    Analytics.trackClicksOn(findDOMNode(this));
  }

  componentWillUnmount() {
    Analytics.untrackClicksOn(findDOMNode(this));
  }

  render() {
    const { trackingProperties, eventName, ...otherProps } = this.props;
    const dataAttribute = JSON.stringify(trackingProperties);
    return (
      <a
        data-venuu-t={dataAttribute}
        data-venuu-t-name={eventName}
        {...otherProps}
      >
        {this.props.children}
      </a>
    );
  }
}

export default TrackedLink;
